import { render, staticRenderFns } from "./RouteChart.vue?vue&type=template&id=58bb9986"
import script from "./RouteChart.vue?vue&type=script&lang=ts"
export * from "./RouteChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports